import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Dropdown = ({
  styles = 'w-5 h-5',
  fill = COLOR.PRIMARY.LIGHT_900,
  fillDarkMode = COLOR.PRIMARY.DARK_500,
  ...rest
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      className={`dark:fill-white ${styles}`}
      fill={fillColor}
      viewBox='-6.5 0 32 32'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
      {...rest}>
      <g
        id='SVGRepo_tracerCarrier'
        strokeLinecap='round'
        strokeLinejoin='round'></g>
      <g id='SVGRepo_iconCarrier'>
        <path d='M18.813 11.406l-7.906 9.906c-0.75 0.906-1.906 0.906-2.625 0l-7.906-9.906c-0.75-0.938-0.375-1.656 0.781-1.656h16.875c1.188 0 1.531 0.719 0.781 1.656z'></path>
      </g>
    </svg>
  );
};

export default Dropdown;
